import React from "react";
import AppShell from "../components/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Info } from "lucide-react";
import { AddToMealLogButton } from "../components/AddToMealLogButton";

const COMIDAS = [
  {
    id: "c1",
    name: "Pollo con arroz y ensalada",
    ingredients: ["Pechuga de pollo cocida (120 g)", "Arroz blanco cocido (100 g)", "Ensalada de tomate, pepino y col"],
    portion: "1 plato principal",
    calories: "380–420",
    protein_g: "39–40",
  },
  {
    id: "c2",
    name: "Arroz, frijoles y huevo",
    ingredients: ["Arroz blanco cocido (100 g)", "Frijoles cocidos (120 g)", "2 huevos"],
    portion: "1 plato",
    calories: "430–450",
    protein_g: "25–26",
  },
  {
    id: "c3",
    name: "Pescado con boniato",
    ingredients: ["Pescado blanco cocido (130–150 g)", "Boniato hervido (150 g)", "Ensalada verde"],
    portion: "1 plato",
    calories: "350–400",
    protein_g: "31–35",
  },
  {
    id: "c4",
    name: "Cerdo magro con yuca y ensalada",
    ingredients: ["Cerdo magro cocido (120 g)", "Yuca hervida (150 g)", "Ensalada de tomate y lechuga"],
    portion: "1 plato",
    calories: "500–550",
    protein_g: "32–34",
  },
  {
    id: "c5",
    name: "Tortilla de huevo con vegetales",
    ingredients: ["3 huevos + 1 clara adicional", "Cebolla, tomate y ají picados", "Poco aceite"],
    portion: "1 tortilla mediana",
    calories: "300–330",
    protein_g: "22–23",
  },
  {
    id: "c6a",
    name: "Pollo con malanga",
    ingredients: ["Pollo cocido (120 g)", "Malanga hervida (200 g)", "Ensalada verde"],
    portion: "1 plato",
    calories: "430–470",
    protein_g: "37–39",
  },
  {
    id: "c6b",
    name: "Pollo con calabaza",
    ingredients: ["Pollo cocido (120 g)", "Calabaza hervida (200 g)", "Ensalada verde"],
    portion: "1 plato",
    calories: "280–320",
    protein_g: "37–39",
  },
  {
    id: "c7a",
    name: "Arroz con atún",
    ingredients: ["Arroz cocido (100 g)", "Atún al agua escurrido (100 g)", "Tomate y cebolla"],
    portion: "1 plato",
    calories: "270–310",
    protein_g: "27–29",
  },
  {
    id: "c7b",
    name: "Arroz con sardinas",
    ingredients: ["Arroz cocido (100 g)", "Sardinas escurridas (100 g)", "Tomate y cebolla"],
    portion: "1 plato",
    calories: "340–380",
    protein_g: "27–29",
  },
  {
    id: "c8",
    name: "Frijoles con arroz y huevo hervido",
    ingredients: ["Arroz cocido (100 g)", "Frijoles cocidos (120 g)", "2 huevos hervidos"],
    portion: "1 plato",
    calories: "430–470",
    protein_g: "25–26",
  },
];

const SNACKS = [
  {
    id: "s1",
    name: "2 huevos hervidos + 1 fruta pequeña",
    ingredients: ["2 huevos hervidos", "1 fruta pequeña (mango, guayaba, plátano fruta)"],
    portion: "1 snack",
    calories: "200–230",
    protein_g: "13",
  },
  {
    id: "s2",
    name: "2 huevos + boniato hervido",
    ingredients: ["2 huevos hervidos o revueltos", "Boniato hervido (100 g)"],
    portion: "1 snack",
    calories: "230–250",
    protein_g: "14",
  },
  {
    id: "s3",
    name: "Queso fresco con fruta",
    ingredients: ["Queso blanco fresco (50 g)", "1 fruta pequeña"],
    portion: "1 snack",
    calories: "200–250",
    protein_g: "10–12",
  },
  {
    id: "s4",
    name: "Yogur natural con maní",
    ingredients: ["Yogur natural sin azúcar añadida (200 ml)", "Maní tostado (20 g)"],
    portion: "1 vaso",
    calories: "230–270",
    protein_g: "12–14",
  },
  {
    id: "s5",
    name: "Leche con maní molido",
    ingredients: ["Leche sin azúcar (250 ml)", "Maní molido (25 g)"],
    portion: "1 vaso",
    calories: "250–300",
    protein_g: "13–15",
  },
  {
    id: "s6",
    name: "Atún con arroz o galletas saladas",
    ingredients: ["Atún al agua escurrido (80 g)", "Porción pequeña de galletas saladas o arroz cocido"],
    portion: "1 snack",
    calories: "220–260",
    protein_g: "20",
  },
  {
    id: "s7",
    name: "Sardinas con boniato hervido",
    ingredients: ["Sardinas escurridas (70–80 g)", "Boniato hervido (100 g)"],
    portion: "1 snack",
    calories: "230–280",
    protein_g: "17–20",
  },
  {
    id: "s8",
    name: "Tortilla rápida de huevo",
    ingredients: ["2 huevos + 1 clara", "Tomate y cebolla picados", "Poco aceite"],
    portion: "1 tortilla pequeña",
    calories: "190–220",
    protein_g: "16–17",
  },
];

// Carbs / fats (g) computed once from ingredients, reconciled with the range midpoint. null = pending.
const CUBA_CF = {
  c1: [33, 12], c2: [56, 13], c3: [34, 12], c4: [61, 17], c5: [7, 22], c6a: [55, 9], c6b: [19, 8],
  c7a: [33, 5], c7b: [33, 13], c8: [56, 14],
  s1: [21, 9], s2: [21, 11], s3: [21, 11], s4: [13, 16], s5: [16, 17], s6: [25, 7], s7: [20, 11], s8: [5, 13],
};

const mid = (v) => {
  const [a, b] = String(v).split("–").map(Number);
  return b ? (a + b) / 2 : a;
};

const toPreset = (item) => {
  const cf = CUBA_CF[item.id];
  return {
    id: `cuba-${item.id}`, name: item.name, kcal: mid(item.calories), protein_g: mid(item.protein_g),
    carbs_g: cf ? cf[0] : null, fats_g: cf ? cf[1] : null,
  };
};

const Card = ({ item, mealType }) => (
  <article className="mep-card p-5 flex flex-col" data-testid={`cuba-food-${item.id}`}>
    <h3 className="font-display text-lg font-medium tracking-tight">{item.name}</h3>
    <div className="flex gap-2 mt-3 text-xs flex-wrap">
      <span className="mep-pill-pink !text-[10px] !py-1 !px-2">{item.protein_g} g proteína aprox.</span>
      <span className="mep-pill-gold !text-[10px] !py-1 !px-2">{item.calories} kcal aprox.</span>
      <span className="text-[10px] uppercase tracking-[0.18em] border border-[var(--mep-border)] text-[var(--mep-text-muted)] rounded-full px-2 py-1">
        {item.portion}
      </span>
    </div>
    <div className="mt-4 text-eyebrow">Ingredientes</div>
    <ul className="text-sm text-[var(--mep-text-muted)] mt-2 space-y-1">
      {item.ingredients.map((i, idx) => <li key={idx}>· {i}</li>)}
    </ul>
    <AddToMealLogButton item={toPreset(item)} defaultMealType={mealType} approx />
  </article>
);

export default function AlimentacionCuba() {
  return (
    <AppShell
      title="🇨🇺 Alimentación para Cuba"
      subtitle="Opciones fitness con alimentos fáciles de conseguir en Cuba."
    >
      <div className="max-w-5xl space-y-6" data-testid="cuba-food-page">
        <img
          src="https://customer-assets-jai6qajn.emergentagent.net/job_gym-coach-premium/artifacts/0bi5vvah_ChatGPT%20Image%2028%20ago%202026%2C%2021_10_30.png"
          alt="Alimentación para Cuba — comidas y snacks fitness con alimentos locales"
          loading="eager"
          data-testid="cuba-food-hero-image"
          className="w-full h-auto rounded-2xl border border-[var(--mep-border)] shadow-[0_20px_60px_-25px_rgba(232,61,132,0.35)]"
        />

        <Tabs defaultValue="comidas">
          <TabsList className="bg-[var(--mep-surface)] border border-[var(--mep-border)]">
            <TabsTrigger
              value="comidas"
              data-testid="cuba-food-tab-comidas"
              className="data-[state=active]:bg-[var(--mep-pink)] data-[state=active]:text-white"
            >
              Comidas
            </TabsTrigger>
            <TabsTrigger
              value="snacks"
              data-testid="cuba-food-tab-snacks"
              className="data-[state=active]:bg-[var(--mep-pink)] data-[state=active]:text-white"
            >
              Snacks
            </TabsTrigger>
          </TabsList>

          <TabsContent value="comidas">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
              {COMIDAS.map((item) => <Card key={item.id} item={item} mealType="almuerzo" />)}
            </div>
          </TabsContent>
          <TabsContent value="snacks">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
              {SNACKS.map((item) => <Card key={item.id} item={item} mealType="snacks" />)}
            </div>
          </TabsContent>
        </Tabs>

        <div
          data-testid="cuba-food-note"
          className="mep-card p-5 md:p-6 border-l-4 border-[var(--mep-gold)] bg-[rgba(212,175,55,0.05)]"
        >
          <div className="flex items-start gap-3">
            <Info size={18} className="text-[var(--mep-gold)] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-[var(--mep-text-muted)] leading-relaxed">
              Puedes sustituir los alimentos según disponibilidad manteniendo una fuente de proteína, una porción de carbohidratos y vegetales.
            </p>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
